"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcChartsForView = void 0;
const ChartType_1 = __importDefault(require("@opsbase/lib-chart/ChartType"));
const ChartVariant_1 = __importDefault(require("@opsbase/lib-chart/ChartVariant"));
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const findGroupByKey_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findGroupByKey"));
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
function calcChartsForView(view) {
    var _a, _b;
    // Start defining the new ChartBox
    const visible = view.chartBox.visible;
    let charts = [];
    const dateFilters = view.filters.filter(f => { var _a; return ((_a = QueryFieldRegistry_1.default[f.queryFieldKey]) === null || _a === void 0 ? void 0 : _a.fieldType) === BasicFieldType_1.default.DATE; });
    const hasTimeFilter = dateFilters.find(f => f.id === 'time');
    const dateFilter = dateFilters === null || dateFilters === void 0 ? void 0 : dateFilters[0];
    const hasGroupBys = !!view.groupBys.length;
    const hasDateFilterLargerThan3Days = (0, moment_timezone_1.default)(dateFilter === null || dateFilter === void 0 ? void 0 : dateFilter.to).diff((0, moment_timezone_1.default)(dateFilter === null || dateFilter === void 0 ? void 0 : dateFilter.from), 'days') > 3;
    const needsCountGroupTimeChart = !hasTimeFilter && hasGroupBys && hasDateFilterLargerThan3Days;
    const needsCountTimeChart = !hasTimeFilter && !hasGroupBys && hasDateFilterLargerThan3Days;
    // ----------------------
    // COUNT/GROUP/TIME chart
    // ----------------------
    if (needsCountGroupTimeChart) {
        // Find current Count/Group/Time Chart if it exists
        let countGroupTimeChart = view.chartBox.charts.find(c => c.chartVariant === ChartVariant_1.default.COUNT_GROUP_TIME);
        // If we haven't already got one, we need to create one
        if (!countGroupTimeChart) {
            countGroupTimeChart = {
                key: dateFilter === null || dateFilter === void 0 ? void 0 : dateFilter.queryFieldKey,
                chartType: ChartType_1.default.BAR3DSTACK,
                chartVariant: ChartVariant_1.default.COUNT_GROUP_TIME,
                config: {
                    timeDimension: dateFilter === null || dateFilter === void 0 ? void 0 : dateFilter.queryFieldKey,
                    otherDimension: ((_b = (_a = view.groupBys) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.queryFieldKey) || undefined,
                },
            };
        }
        // Otherwise, if we DO already have one, does it point to one of
        // our current Date Filters?
        else if (!dateFilters.find(d => d.queryFieldKey === countGroupTimeChart.key)) {
            countGroupTimeChart.key = dateFilter === null || dateFilter === void 0 ? void 0 : dateFilter.queryFieldKey;
            countGroupTimeChart.config.timeDimension = dateFilter === null || dateFilter === void 0 ? void 0 : dateFilter.queryFieldKey;
        }
        // Set the group dimension if we need to
        if (!(0, findGroupByKey_1.default)(view.groupBys, countGroupTimeChart.config.otherDimension)) {
            countGroupTimeChart.config.otherDimension = view.groupBys[0].queryFieldKey;
        }
        // All good... lets add our chart
        charts.push(countGroupTimeChart);
    }
    // ----------------------
    // COUNT/TIME chart
    // ----------------------
    if (needsCountTimeChart) {
        // Find current Count/Group/Time Chart if it exists
        let countTimeChart = view.chartBox.charts.find(c => c.chartVariant === ChartVariant_1.default.COUNT_TIME);
        // If we haven't already got one, we need to create one
        if (!countTimeChart) {
            countTimeChart = {
                key: dateFilter === null || dateFilter === void 0 ? void 0 : dateFilter.queryFieldKey,
                chartType: ChartType_1.default.BAR2D,
                chartVariant: ChartVariant_1.default.COUNT_TIME,
                config: {
                    timeDimension: dateFilter === null || dateFilter === void 0 ? void 0 : dateFilter.queryFieldKey,
                },
            };
        }
        // Otherwise, if we DO already have one, does it point to one of
        // our current Date Filters?
        else if (!dateFilters.find(d => d.queryFieldKey === countTimeChart.key)) {
            countTimeChart.key = dateFilter === null || dateFilter === void 0 ? void 0 : dateFilter.queryFieldKey;
            countTimeChart.config.timeDimension = dateFilter === null || dateFilter === void 0 ? void 0 : dateFilter.queryFieldKey;
        }
        // All good... lets add our chart
        charts.push(countTimeChart);
    }
    // ----------------------
    // COUNT/GROUP charts
    // ----------------------
    if (hasGroupBys) {
        const existingCountGroupCharts = view.groupBys
            .map(g => view.chartBox.charts.find(c => c.key === g.queryFieldKey))
            .filter(c => !!c);
        charts = charts.concat(existingCountGroupCharts);
        // Any non-existing Count/Group charts should be added
        const newCountGroupCharts = view.groupBys.filter(gb => gb && !view.chartBox.charts.find(c => c.key === gb.queryFieldKey));
        charts = charts.concat(newCountGroupCharts.map(groupBy => ({
            key: groupBy.queryFieldKey,
            chartType: ChartType_1.default.PIE2D,
            chartVariant: ChartVariant_1.default.COUNT_GROUP,
            config: { dimension: groupBy.queryFieldKey },
        })));
    }
    // ----------------------
    // SCORE/Q/OP charts
    // ----------------------
    view.chartBox.charts
        .filter(chart => chart.chartVariant === ChartVariant_1.default.SCORE_Q_OP)
        .forEach(chart => {
        charts.push(Object.assign(Object.assign({}, chart), { hidden: hasGroupBys }));
    });
    // Done
    const nowHasCharts = !!charts.length;
    view.chartBox = {
        visible: visible === undefined ? nowHasCharts : visible && nowHasCharts,
        charts,
    };
}
exports.calcChartsForView = calcChartsForView;
exports.default = calcChartsForView;
